export const IMOVEL_STATUS = Object.freeze({
  DISPONIVEL: 'disponivel',
  RESERVADO: 'reservado',
  VENDIDO: 'vendido',
  ALUGADO: 'alugado',
  INATIVO: 'inativo',
});

export const IMOVEL_LISTING_STATUS = Object.freeze({
  EDICAO: 'edicao',
  PUBLICADO: 'publicado',
  DESPUBLICADO: 'despublicado',
  SUSPENSO: 'suspenso',
  OPTED_OUT: 'opted_out',
});

export const IMOVEL_FINALIDADE = Object.freeze({
  VENDA: 'venda',
  ALUGUEL: 'aluguel',
  TEMPORADA: 'temporada',
});

export const IMOVEL_TIPO_LABELS = Object.freeze({
  apartamento: 'Apartamento',
  studio: 'Kitnet/Studio',
  casa: 'Casa',
  casa_condominio: 'Casa em condomínio',
  cobertura: 'Cobertura',
  sobrado: 'Sobrado',
  loft: 'Loft',
  flat: 'Flat',
  terreno: 'Terreno',
  comercial: 'Comercial',
  sala_comercial: 'Sala comercial',
  galpao: 'Galpão',
  chacara: 'Chácara',
});

export const IMOVEL_STATUS_LABELS = Object.freeze({
  incompleto: 'Anúncio incompleto',
  esperado: 'Anúncio em breve',
  fotos_pendentes: 'Agendamento de fotos pendente',
  fotos_agendadas: 'Sessão de fotos agendada',
  fotos_com_problema: 'Imprevisto nas fotos',
  preco_desatualizado: 'Preço desatualizado',
  old_updated: 'Preço desatualizado',
  oldUpdated: 'Preço desatualizado',
  poucas_fotos: 'Poucas fotos disponíveis',
  insufficient_photos: 'Poucas fotos disponíveis',
  insufficientPhotos: 'Poucas fotos disponíveis',
  imagem_qualidade_baixa: 'Qualidade das imagens abaixo do permitido',
  image_quality: 'Qualidade das imagens abaixo do permitido',
  imageQuality: 'Qualidade das imagens abaixo do permitido',
  fora_da_area: 'Imóvel fora da área de atuação',
  outside_operation_area: 'Imóvel fora da área de atuação',
  fora_do_preco: 'Fora do preço de atuação da Imudei',
  price_range: 'Fora do preço de atuação da Imudei',
  priceRange: 'Fora do preço de atuação da Imudei',
  duplicado: 'Imóvel duplicado',
  duplicated_house: 'Imóvel duplicado',
  duplicatedHouse: 'Imóvel duplicado',
  indisponivel: 'Imóvel indisponível',
  house_not_available: 'Imóvel indisponível',
  houseNotAvailable: 'Imóvel indisponível',
  disponivel: 'Disponível',
  anunciado: 'Disponível',
  alta_procura: 'Anúncio com muita procura',
  reservado: 'Reservado',
  antecipado: 'Anúncio antecipado',
  contrato_ativo: 'Contrato ativo',
  rescisao: 'Em processo de rescisão',
  vendido: 'Vendido',
  alugado: 'Alugado',
  inativo: 'Desativado',
  pausado: 'Pausado',
});

export const IMOVEL_STATUS_CLASSES = Object.freeze({
  disponivel: 'text-emerald-700 bg-emerald-50',
  anunciado: 'text-emerald-700 bg-emerald-50',
  reservado: 'text-amber-700 bg-amber-50',
  alta_procura: 'text-amber-700 bg-amber-50',
  vendido: 'text-slate-700 bg-slate-100',
  alugado: 'text-slate-700 bg-slate-100',
  inativo: 'text-rose-700 bg-rose-50',
  indisponivel: 'text-rose-700 bg-rose-50',
  house_not_available: 'text-rose-700 bg-rose-50',
  houseNotAvailable: 'text-rose-700 bg-rose-50',
});

export const IMOVEL_LISTING_STATUS_LABELS = Object.freeze({
  [IMOVEL_LISTING_STATUS.EDICAO]: 'Em edição',
  [IMOVEL_LISTING_STATUS.PUBLICADO]: 'Publicado',
  [IMOVEL_LISTING_STATUS.DESPUBLICADO]: 'Despublicado',
  [IMOVEL_LISTING_STATUS.SUSPENSO]: 'Suspenso',
  [IMOVEL_LISTING_STATUS.OPTED_OUT]: 'Opt-out',
});

export const IMOVEL_FINALIDADE_LABELS = Object.freeze({
  [IMOVEL_FINALIDADE.VENDA]: 'Venda',
  [IMOVEL_FINALIDADE.ALUGUEL]: 'Aluguel',
  [IMOVEL_FINALIDADE.TEMPORADA]: 'Temporada',
});

export const UNIT_AMENITY_TYPES = Object.freeze({
  AREA: 'AREA',
  BEDROOM: 'BEDROOM',
  BATHROOM: 'BATHROOM',
  PARKING: 'PARKING',
  FLOOR: 'FLOOR',
  PETS: 'PETS',
  FURNITURE: 'FURNITURE',
  SUBWAY: 'SUBWAY',
});

export const RENTAL_GUARANTEE_TYPES = Object.freeze({
  STANDALONE: 'standalone',
  THIRD_PARTY_GUARANTEE: 'third_party_guarantee',
});

export const RENTAL_ADMINISTRATOR_TO_GUARANTEE_TYPE = Object.freeze({
  owner: RENTAL_GUARANTEE_TYPES.STANDALONE,
  imobiliaria: RENTAL_GUARANTEE_TYPES.THIRD_PARTY_GUARANTEE,
  terceiro: RENTAL_GUARANTEE_TYPES.THIRD_PARTY_GUARANTEE,
});

export const RENTAL_GUARANTEE_LABELS = Object.freeze({
  [RENTAL_GUARANTEE_TYPES.STANDALONE]: 'Fiança Simples',
  [RENTAL_GUARANTEE_TYPES.THIRD_PARTY_GUARANTEE]: 'Fiança Locatícia',
});

export const PRICE_ROW_KINDS = Object.freeze({
  RENT_PRICE: 'RENT_PRICE',
  RENT: 'RENT',
  SALE_PRICE: 'SALE_PRICE',
  SALE: 'SALE',
  CONDO_PRICE: 'CONDO_PRICE',
  CONDOMINIUM: 'CONDOMINIUM',
  PROPERTY_TAX: 'PROPERTY_TAX',
  HOUSE_TAX: 'HOUSE_TAX',
  HOME_PROTECTION: 'HOME_PROTECTION',
  TENANT_SERVICE_FEE: 'TENANT_SERVICE_FEE',
  RENTAL_GUARANTEE: 'RENTAL_GUARANTEE',
  TOTAL_COST: 'TOTAL_COST',
});

export {
  QA_CONDOMINIUM_TYPE_LABELS as CONDOMINIUM_TYPE_LABELS,
  QA_CONDOMINIUM_TYPES as CONDOMINIUM_TYPES,
  QA_HOUSE_STATUS_BY_REFERENCE as HOUSE_STATUS_BY_REFERENCE,
  QA_HOUSE_TYPE_BY_REFERENCE as HOUSE_TYPE_BY_REFERENCE,
  QA_IPTU_TYPE_LABELS as IPTU_TYPE_LABELS,
  QA_IPTU_TYPES as IPTU_TYPES,
  QA_RENTAL_ADMINISTRATOR_BY_REFERENCE as RENTAL_ADMINISTRATOR_BY_REFERENCE,
  normalizeQaAmenityType as normalizeUnitAmenityType,
  normalizeQaHouseType as normalizeImovelTipo,
} from './quintoAndarParity';

export default IMOVEL_STATUS;
